export default function useImageHelpers() {
	const config = useRuntimeConfig();

	function replaceImageSrc(url = "") {
		return url.replace(config.public.imgUrl, "/cds/");
	}

	return { replaceImageSrc };
}
